"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryMapper = void 0;
const jsonapi_utils_1 = require("../../../#core/jsonapi-utils");
class CategoryMapper {
    toCategory(categoryResource) {
        return {
            id: categoryResource.id,
            createdAt: new Date(categoryResource.attributes.createdAt),
            updatedAt: new Date(categoryResource.attributes.updatedAt),
            proprietaryId: categoryResource.attributes.proprietaryId,
            title: categoryResource.attributes.title,
            parentId: jsonapi_utils_1.pluckRelationshipId(categoryResource.relationships.parent),
            organizationId: jsonapi_utils_1.pluckRelationshipId(categoryResource.relationships.organization),
        };
    }
    toCategoryResource(category) {
        return {
            id: category.id,
            type: 'Category',
            attributes: {
                createdAt: category.createdAt.toISOString(),
                updatedAt: category.updatedAt.toISOString(),
                proprietaryId: category.proprietaryId,
                title: category.title,
            },
            relationships: {
                parent: jsonapi_utils_1.createRelationship(category.parentId, (id) => ({ type: 'Category', id })),
                organization: jsonapi_utils_1.createRelationship(category.organizationId, (id) => ({ type: 'Organization', id })),
            },
        };
    }
    toCategoryCreation(categoryCreationResource) {
        return {
            proprietaryId: categoryCreationResource.attributes.proprietaryId,
            title: categoryCreationResource.attributes.title,
            parentId: jsonapi_utils_1.pluckRelationshipId(categoryCreationResource.relationships.parent),
            organizationId: jsonapi_utils_1.pluckRelationshipId(categoryCreationResource.relationships.organization),
        };
    }
    toCategoryCreationResource(categoryCreation) {
        return {
            type: 'Category',
            attributes: {
                proprietaryId: categoryCreation.proprietaryId,
                title: categoryCreation.title,
            },
            relationships: {
                parent: jsonapi_utils_1.createRelationship(categoryCreation.parentId, (id) => ({ type: 'Category', id })),
                organization: jsonapi_utils_1.createRelationship(categoryCreation.organizationId, (id) => ({ type: 'Organization', id })),
            },
        };
    }
    toCategoryUpdate(categoryUpdateResource) {
        return {
            id: categoryUpdateResource.id,
            proprietaryId: categoryUpdateResource.attributes.proprietaryId,
            title: categoryUpdateResource.attributes.title,
        };
    }
    toCategoryUpdateResource(categoryUpdate) {
        return {
            id: categoryUpdate.id,
            type: 'Category',
            attributes: {
                proprietaryId: categoryUpdate.proprietaryId,
                title: categoryUpdate.title,
            },
        };
    }
}
exports.CategoryMapper = CategoryMapper;
//# sourceMappingURL=#category-mapper.js.map